var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('article',{staticClass:"medicine-status clearfix"},[(!_vm.img)?_c('p',{staticClass:"tips"},[_vm._v("正在加载中...")]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.img,"loading":"lazy"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a9e5ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/solutionProramme.vue
// module id = null
// module chunks = 